export default {
  network: {
    ETH: {
      depositAddress: '0x00000000219ab540356cBB839Cbe05303d7705Fa',
      endpoint: 'https://staked.mewapi.io',
      batchContract: '0xF243A92eB7D4B4F6A00A57888B887bd01ec6fd12',
      url: 'https://beaconcha.in/validator/',
      etherscanTxUrl: 'https://etherscan.io/tx/',
      ethvmTxUrl: 'https://www.ethvm.com/tx/',
      etherscanAddrUrl: 'https://etherscan.io/address/',
      ethvmAddrUrl: 'https://www.ethvm.com/address/'
    }
  }
};
